module.exports = __webpack_public_path__ + "static/img/产品图@2x.1a97320.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/产品图@2x.png
// module id = H+2M
// module chunks = 192